const makeInitialState = () => ({
  clientId: null
});

export default makeInitialState;
